export const RETURN_URL_QUERY_PARAM_KEY = 'returnURL';